import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpEvent, HttpParams } from '@angular/common/http';

import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserserviceService {

// url: string ='http://localhost/Migration-portal-APIs/index.php';   
// url: string = 'http://43.204.98.97/cert_issue_test/certificate_issuance_rest/index.php'; //test envi
url: string ='https://service2.gbshse.in/cert_issue/certificate_issuance_rest/index.php';// live 

loginuserdetail:any;

  constructor(public router: Router,private route: ActivatedRoute,private httpClient: HttpClient) { 
   
  }

get(endpoint: string, params?: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams()
      };
    }
    // Support easy query params for GET requests
    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }
    return this.httpClient.get(this.url + '/' + endpoint, reqOpts);
  }
  post(endpoint: string, body: any,params?: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams(),
      };
    }
    // Support easy query params for GET requests
    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }
   // console.log("Body :"+JSON.stringify(body));
     return this.httpClient.post(this.url + endpoint, body, reqOpts);
  
 }
 put(endpoint: string, body: any, reqOpts?: any) {
  return this.httpClient.put(this.url + '/' + endpoint, body, reqOpts);
 }
 
 delete(endpoint: string, reqOpts?: any) {
  return this.httpClient.delete(this.url + '/' + endpoint, reqOpts);
 }
 
 patch(endpoint: string, body: any, reqOpts?: any) {
  return this.httpClient.patch(this.url + '/' + endpoint, body, reqOpts);
 }
 


  logout() {
    let c=confirm("Are you sure to log off??");
    if(c==true){
        // remove user from local storage to log user out
        // this.userSubject.next(null);
        if( sessionStorage.getItem('roleid')=="1"){
          const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/Login';
          this.router.navigateByUrl(returnUrl).then(() => {
            window.location.reload();
           });
        }
        else{
          const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/boardadminlogin';
          this.router.navigateByUrl(returnUrl).then(() => {
            window.location.reload();
           });
          // this.router.navigate(['/boardadminlogin']);
        }
        //  sessionStorage.clear();
        sessionStorage.removeItem('loggeduser');
        sessionStorage.removeItem('loggeduserid');
        sessionStorage.removeItem('roleid');
   }
    
  }


}
